import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface EmailVerificationForCandidateResponse
  extends BackendResponse {item: EmailVerificationStatus}

export const checkEmailVerification =
  withNextApi<EmailVerificationForCandidateResponse>("/cvp/CvpCheckEmailVerification");

export enum EmailVerificationStatus{
  Verified,
  NotVerified,
  Pending,
  Expired,
  PendingEmailChange
}